var map = {
	"./AperitivosSnack.png": "c9fc",
	"./DRYMARTINI.png": "b815",
	"./SPAF.png": "50a1",
	"./alegriagroup.png": "a3567",
	"./amarresdebarcelona.png": "a6b6",
	"./aquahotel.png": "4a49",
	"./asutex.png": "3346",
	"./barcelonaactiva.png": "bcea",
	"./butransa.png": "9217",
	"./cnab.png": "4787",
	"./coca-cola.png": "c502",
	"./emera.jpg": "95e8",
	"./enteco.png": "c29e",
	"./fondo.jpg": "2695",
	"./grapehospitality.png": "21ff",
	"./grimaldi.png": "f148",
	"./grimaldi1.jpg": "7ea7",
	"./grimaldi2.jpg": "6431",
	"./grimaldi3.jpg": "fd5c",
	"./grupoanfi.jpg": "730f",
	"./grupohoteleslopez.png": "7831",
	"./gruporafe.png": "3287",
	"./gt.png": "1311",
	"./gt.webp": "1d36",
	"./inserLogo.png": "ad60",
	"./natac.png": "14ee",
	"./rudder.png": "bdc5",
	"./sauleda.png": "3338",
	"./solarProfit.png": "f39c",
	"./trasmed.png": "d149",
	"./wallapop.png": "f0f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";